import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ranking-item" }
const _hoisted_2 = { class: "ranking-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_4 = { class: "item-tile" }
const _hoisted_5 = { class: "leading" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "info-text template-info" }
const _hoisted_9 = { class: "sub-text" }
const _hoisted_10 = { class: "count" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: require('icons/primary-template.svg'),
              alt: "template icon"
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", null, _toDisplayString(item.title), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(item.updatedAt
                    ? `${_ctx.$t("template.lastUpdate")} ${_ctx.formatDate(
                        item.updatedAt,
                        "YYYY/MM/DD"
                      )}`
                    : ""), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.count) + _toDisplayString(_ctx.$t("dashboard.countText")), 1)
          ])
        ]),
        _hoisted_11
      ]))
    }), 128))
  ]))
}